import React, { useEffect, useRef } from 'react';
import { Ic, ICONS } from '../../data/icons';

export default function CustomContextMenu({ x, y, options, onClose, C }) {
  const menuRef = useRef();

  useEffect(() => {
    const handleClick = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        onClose();
      }
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [onClose]);

  // Map option labels to icon keys in ICONS
  const labelToIcon = {
    'Dosya Yükle': 'upload',
    'Uzak Masaüstü': 'monitor',
    'File manager': 'folder',
    'Process manager': 'server',
    'Window manager': 'grid',
    'Clipboard manager': 'copy',
    'Registry manager': 'settings',
    'Startup manager': 'refresh',
    'Command prompt': 'terminal',
    'TCP connection': 'wifi',
    'Remote webcam monitoring': 'camera',
    'Remote microphone monitoring': 'mic',
    'Password recovery': 'key',
  };

  // Fallback for missing icons
  const fallbackIcon = 'chevR';
  // Animasyon için state
  const [visible, setVisible] = React.useState(false);
  React.useEffect(() => { setVisible(true); return () => setVisible(false); }, []);

  return (
    <div
      ref={menuRef}
      onClick={e => e.stopPropagation()}
      style={{
        position: 'fixed',
        top: y,
        left: x,
        background: C?.surface || '#fff',
        color: C?.text || '#222',
        borderRadius: 8,
        boxShadow: '0 2px 8px #0004',
        border: `1.5px solid ${C?.border || '#ddd'}`,
        minWidth: 180,
        zIndex: 9999,
        padding: '6px 0',
        fontSize: 14,
        opacity: visible ? 1 : 0,
        transform: visible ? 'scale(1)' : 'scale(0.97)',
        transition: 'opacity 0.18s cubic-bezier(.4,0,.2,1), transform 0.18s cubic-bezier(.4,0,.2,1)'
      }}
    >
      {options.map(opt => {
        const iconKey = labelToIcon[opt.label] || fallbackIcon;
        return (
          <div
            key={opt.label}
            onClick={e => { e.stopPropagation(); opt.onClick(); onClose(); }}
            style={{
              padding: '9px 18px',
              cursor: 'pointer',
              borderBottom: `1px solid ${C?.border2 || '#eee'}`,
              background: opt.danger ? (C?.redBg || '#ef444420') : 'none',
              color: opt.danger ? (C?.red || '#ef4444') : (C?.text || '#222'),
              fontWeight: opt.danger ? 700 : 500,
              display: 'flex',
              alignItems: 'center',
              gap: 10
            }}
          >
            <span style={{ display: 'flex', alignItems: 'center', minWidth: 22 }}>
              {ICONS[iconKey] && <Ic d={ICONS[iconKey]} size={18} s={opt.danger ? (C?.red || '#ef4444') : (C?.text || '#222')} />}
            </span>
            {opt.label}
          </div>
        );
      })}

    </div>
  );
}
